module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kX8m0"))).then(() => parcelRequire('jFxo6'));